import { AutoIgnitionState } from 'console/device/types';
import { isWebasto } from 'console/shared/content/device/vehicle-controls';
import { vehicle_controls_state } from 'console/shared/content/device/vehicle-controls/utils';
import { useLegacyDeviceState } from './index';
import { useSelectDevice } from '../index';
function getAutoStartControlState(auto_ignition, active) {
    const { state, available, configuration } = auto_ignition;
    const webasto_state = active
        ? 'autostart-webasto-turned-on'
        : 'autostart-webasto-turned-off';
    const autostart_state = active ? 'autostart-turned-on' : 'autostart-turned-off';
    const has_webasto = state === AutoIgnitionState.disabled && available && configuration?.webasto;
    const is_webasto = isWebasto(state) || has_webasto;
    if (is_webasto) {
        return webasto_state;
    }
    return autostart_state;
}
function getAutoStartCommand(active, auto_ignition) {
    if (!auto_ignition) {
        return AutoIgnitionState.disabled;
    }
    const { state, configuration, available, current_mode } = auto_ignition;
    if (isWebasto(state) && configuration.engine && available && current_mode.engine) {
        return AutoIgnitionState.enabled;
    }
    if (active) {
        return AutoIgnitionState.disabled;
    }
    return AutoIgnitionState.enabled;
}
const useAutostartVehicleControlState = (config, auto_ignition, loading = false, fail = false, fail_message = '') => () => {
    const { onClick } = config;
    const active = auto_ignition
        ? auto_ignition.state !== AutoIgnitionState.disabled
        : false;
    const autostart_command = getAutoStartCommand(active, auto_ignition);
    const onVehicleControlClick = () => onClick(autostart_command);
    const control_state = auto_ignition
        ? getAutoStartControlState(auto_ignition, active)
        : null;
    return {
        active,
        loading,
        fail,
        fail_message,
        control_state,
        onClick: onVehicleControlClick,
    };
};
const useGuardVehicleControlState = (config, state, loading = false, fail = false, fail_message = '') => () => {
    const { onClick } = config;
    const active = state ? ['enabled', 'enabling'].includes(state) : false;
    const activating = state === 'enabling';
    const onVehicleControlClick = () => onClick(!active);
    const control_state = active
        ? 'guard-turned-on'
        : activating
            ? 'guard-activating'
            : 'guard-turned-off';
    return {
        active,
        loading,
        fail,
        fail_message,
        control_state,
        onClick: onVehicleControlClick,
    };
};
const useSimpleVehicleControlState = (config, state = false, loading = false, fail = false, fail_message = '') => () => {
    const { control_type, onClick } = config;
    const active = state;
    const control_state = `${control_type}-${active ? 'turned-on' : 'turned-off'}`;
    const onVehicleControlClick = () => onClick(!active);
    return {
        active,
        loading,
        fail,
        fail_message,
        control_state,
        onClick: onVehicleControlClick,
    };
};
export const useVehicleControlsStateHook = (config) => {
    const { control_type } = config;
    const initial_state = useSelectDevice(vehicle_controls_state);
    const { webasto, webasto__loading, webasto__fail, siren, siren__loading, siren__fail, engine_block, engine_block__loading, engine_block__fail, guard_state, guard_state__loading, guard_state__fail, auto_ignition, auto_ignition__loading, auto_ignition__fail, action_fail_message, } = useLegacyDeviceState(initial_state);
    if (control_type === 'siren') {
        return useSimpleVehicleControlState(config, siren, siren__loading, siren__fail, action_fail_message);
    }
    if (control_type === 'engine') {
        return useSimpleVehicleControlState(config, engine_block, engine_block__loading, engine_block__fail, action_fail_message);
    }
    if (control_type === 'webasto') {
        return useSimpleVehicleControlState(config, webasto, webasto__loading, webasto__fail, action_fail_message);
    }
    if (control_type === 'guard') {
        return useGuardVehicleControlState(config, guard_state, guard_state__loading, guard_state__fail, action_fail_message);
    }
    return useAutostartVehicleControlState(config, auto_ignition, auto_ignition__loading, auto_ignition__fail, action_fail_message);
};
